
<div *ngIf="!loggedin else loggedInContent">
    <div class="series-banner series-banner-guest" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll">
        <img class="series-banner-image" src="assets/signature/layer_6.png" alt="Signature Series banner">
        <div class="series-banner-content">
            <div class="container py-5">
                <div class="row left-content">
                    <div class="text-gold2 h4 text-uppercase" data-aos="fade-up" data-aos-duration="1000"> Level Up Your Coaching!
                    </div>
                    <div class="text-gold2 h4 text-uppercase" data-aos="fade-up" data-aos-duration="1000"> with Industry Experts!
                    </div>
                    <div class="text-gold2 h4 text-uppercase" data-aos="fade-up" data-aos-duration="1000"> Signature Series is Here!
                    </div>
                    <!-- <div class="h2 text-white" data-aos="fade-up" data-aos-duration="1000">
                        Signature Series is Here
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Description -->
<section class="py-5 bg-series-grey px-17">
    <div class="container text-center">
        <h2 class="fw-bold mb-5 text-white">Unlock Exclusive Cheerleading Masterclasses</h2>
        <p class="text-dark-50 text-justify fs-18">Welcome to Signature Series, where the best minds in cheerleading share their expertise through in-depth masterclasses designed exclusively for coaches like you.  
        Gain access to high-level instruction from industry leaders, covering essential topics that will elevate your coaching skills and give your athletes a competitive edge. </p>
    </div>
    <div class="container mt-5 text-white">
        <div class="row">
            <div class="col-lg-6">
            <h4 class="mb-3 text-uppercase mb-5">What is the <span class="text-gold2">Signature Series</span>?</h4>
            <p class="text-dark-50 fs-18">The Signature Series is an expanding, premium collection of expert-led masterclasses, crafted specifically for cheerleading coaches. Each series is structured into multiple chapters, making it easy to absorb and apply the knowledge with your athletes. From advanced stunting techniques to mental preparation strategies, our industry experts break down their specialties into engaging, actionable lessons.</p>
            </div>
            <div class="col-lg-6">
            <div class="ratio ratio-16x9">
                <video _ngcontent-ymi-c37="" oncontextmenu="return false;" controlslist="nodownload" id="player" playsinline="" controls="" poster="assets/images/58bda0de-2d68-45b3-b9dc-76878b63298a.jpeg"><source _ngcontent-ymi-c37="" type="video/mp4" [src]="trailerVideo"></video>
            </div>
            </div>
        </div>
    </div>
</section>


<!-- Topics & Benefits -->
<section class="series-banner2 px-17">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h5 class="text-gold2 text-uppercase">Signature Series Topics Include:</h5>
        <ul class="list-unstyled text-dark-50">
          <li><i class="fas fa-check-square icon-green"></i> Stunting & Tumbling Techniques</li>
          <li><i class="fas fa-check-square icon-green"></i> Competition Scoring & Strategy</li>
          <li><i class="fas fa-check-square icon-green"></i> Leadership & Team Culture</li>
          <li><i class="fas fa-check-square icon-green"></i> Choreography & Routine Design</li>
          <li><i class="fas fa-check-square icon-green"></i> Athlete Mental Toughness & Preparation</li>
          <li>...and much more!</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h5 class="text-gold2 text-uppercase">Why Signature Series?</h5>
        <ul class="list-unstyled text-dark-50">
          <li><i class="fas fa-arrow-right text-gold2"></i> Exclusive Access - Available only to paid subscribers of The Cheer Forge.</li>
          <li><i class="fas fa-arrow-right text-gold2"></i> Industry Experts - Learn directly from top professionals in cheerleading.</li>
          <li><i class="fas fa-arrow-right text-gold2"></i> Practical & Actionable - Step-by-step guidance to implement immediately.</li>
          <li><i class="fas fa-arrow-right text-gold2"></i>Anytime, Anywhere - Watch on-demand, at your convenience.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Subscribe CTA -->
<section class="pb-5 bg-series-grey px-17">
  <div class="container">
    <div class="cta-box p-4 bg-55">
        <div class="row align-items-center">
            <div class="col-md-9">
                <h4 class="text-uppercase">Ready to take your coaching to the next level?</h4>
                <p>Subscribe to The Cheer Forge today and unlock the full Signature Series library and a community of passionate coaches committed to excellence.</p>
            </div>
            <div class="col-md-3 text-center">
                <button class="btn btn-gold2" (click)="login()">Subscribe Now</button>
            </div>
        </div>
    </div>
  </div>
</section>

<!-- Instructors -->

    <section class="instructors-section py-5 bg-series-grey px-17">
        <div class="container">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <h2 class="text-uppercase mb-5 text-white">MEET YOUR <span class="text-gold2">INSTRUCTORS</span></h2>
                    <p class="text-dark-50 text-justify">
                        Our Signature Series features an all-star lineup of coaches, choreographers, and industry leaders who bring their expertise to life in these masterclasses. Get insider knowledge from the best in the business and transform your coaching approach. We continue to add new instructors and series all season long!
                    </p>
                </div>
                <div class="col-md-6 justify-content-center instructors">
                    <img src="assets/brand/signature-instructors.png" alt="Coach 1" class="img-fluid">
                </div>
            </div>
        </div>
    </section>
</div>
<ng-template #loggedInContent>
    <div class="series-banner" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll">
        <!-- Background Video -->
        <!-- <video autoplay muted loop playsinline class="background-video">
            <source src="https://dev.thecheerforge.com/assets/videos/6df6a52f-36e9-493d-bacb-600376792e05SAHIL%20-%20Chapter%202.mp4" type="video/mp4">
        </video> -->
        <img class="series-banner-image" src="assets/signature/layer_6.png" alt="Signature Series banner">
        <div class="series-banner-content">
            <div class="container py-5">
                <div class="row left-content">
                    <div class="text-gold2 h6 text-uppercase" data-aos="fade-up" data-aos-duration="1000"> Level Up Your Coaching with Industry Experts!
                    </div>
                    <div class="h2 text-white" data-aos="fade-up" data-aos-duration="1000">
                        Signature Series is Here
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="series-search-form py-4 bg-white shadow position-relative">
        <div class="container">
            <div class="row g-3">
                <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
                    <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" [(ngModel)]="selectedcategory"
                        class="selectpicker font-oswald w-100">
                        <option value="">Select Category</option>
                        <option *ngFor="let category of categories" value="{{category.id}}">{{category.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
                    <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" [(ngModel)]="selectedinstructor"
                        class="selectpicker font-oswald w-100">
                        <option value="">Select Instructor</option>
                        <option *ngFor="let instructor of instructors" value="{{instructor.id}}">{{instructor.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 col-lg-4" data-aos="fade-left" data-aos-duration="1000">
                    <input class="form-control me-2 rounded-pill px-4" style="height: 40px;" type="input" [(ngModel)]="keyword" placeholder="Search with tag" aria-label="Search">
                </div>
                <div class="col-md-6 ps-md-6 col-lg-2 d-flex align-items-center">
                    <button class="btn btn-lg btn-gold3 me-lg-4 me-2 fs-16" type="button" (click)="search()">Search</button>
                    <button class="btn btn-lg btn-red fs-16" type="button" (click)="reset()">Reset</button>
                </div>
            </div>
        </div>
    </section>
    <section class="series-authors">
        <div class="container py-5">
            <div class="row">
                <ng-container *ngFor="let seriesdata of series; let i=index">
                
                    
                    <div *ngIf="i==-1" class="col-12 feature-box border-series mb-4">
                        <div class="instructor-box bg-series-author" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll" [style]="getStyles(seriesdata)">
                            <img src="{{getInstructorThumbUrl(seriesdata.image)}}">
                        </div>
                        
                        <div class="content-box">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="left-content">
                                        <h4 class="text-uppercase text-gold2">{{seriesdata.name}}</h4>
                                        <p class="text-white ft-wght-300">{{seriesdata.title}}</p>
                                        <div class="chapter-details">
                                            <div class="icon-box">
                                                <i class="fas fa-video"></i>
                                            </div>
                                            <div class="details-box">
                                                <div class="text-white">{{seriesdata.videos_count}} Chapters</div>
                                                <!-- <small class="text-gold">{{seriesdata.duration}} hours</small> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="right-content">
                                        <div class="image-thumb-box" *ngIf="seriesdata.trailor" (click)="openDetails(seriesdata.trailor,'staticBackdrop')">
                                            <img src="{{getThumbUrl(seriesdata.trailor.video_thumb)}}">
                                            <!-- <p>{{seriesdata.trailor.name}}</p> -->
                                            <p class="uppercase">Trailer</p>
                                        </div>
                                        <div *ngIf="(plan && plan.subscription_cancelled!=1 && plan.subscription_cancelled!=2) && seriesdata.featured" class="image-thumb-box" (click)="seriesPlaylist(seriesdata)">
                                            <img height="70px" src="{{getThumbUrl(seriesdata.featured.video_thumb)}}">
                                            <p>Chapters</p>
                                        </div>
                                        <div *ngIf="(!plan || plan.subscription_cancelled==1 || plan.subscription_cancelled==2) && seriesdata.featured" class="image-thumb-box" data-bs-toggle="modal" data-msg="Signature Series is available with a paid subscription. To access this Series, please update your plan!" data-bs-target="#subscription-update-modal" href="javascript:void(0)">
                                            <img height="70px" src="{{getThumbUrl(seriesdata.featured.video_thumb)}}">
                                            <p>Chapters</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                    <div *ngIf="i>=0" class="col-md-6 mt-4">
                        
                        <div class="child-box border-series">
                            <div class="instructor-box p-4 bg-series-author2" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll" [style]="getStyles(seriesdata)">
                                <div class="author-image"><img src="{{getInstructorThumbUrl(seriesdata.image)}}"></div>
                                <div class="author-name">
                                    <h4 class="text-uppercase text-gold2">{{seriesdata.name}}</h4>
                                    <p class="text-white ft-wght-300 mx-4">{{seriesdata.title}}</p>
                                </div>
                            </div>
                            
                            <div class="content-box">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="left-content">
                                            <div class="chapter-details">
                                                <div class="icon-box">
                                                    <i class="fas fa-video"></i>
                                                </div>
                                                <div class="details-box">
                                                    <div class="text-white">{{seriesdata.videos_count}} Chapters</div>
                                                    <!-- <small class="text-gold">2.5 hours</small> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8">
                                        <div class="right-content">
                                            <div class="image-thumb-box" *ngIf="seriesdata.trailor" (click)="openDetails(seriesdata.trailor,'staticBackdrop')">
                                                <img src="{{getThumbUrl(seriesdata.trailor.video_thumb)}}">
                                                <!-- <p>{{seriesdata.trailor.name}}</p> -->
                                                <p class="uppercase">Trailer</p>
                                            </div>
                                            <div *ngIf="(plan && plan.subscription_cancelled!=1 && plan.subscription_cancelled!=2) && seriesdata.featured" class="image-thumb-box" (click)="seriesPlaylist(seriesdata)">
                                                <img src="{{getThumbUrl(seriesdata.featured.video_thumb)}}">
                                                <p>Chapters</p>
                                            </div>
                                            <div *ngIf="(!plan || plan.subscription_cancelled==1 || plan.subscription_cancelled==2) && seriesdata.featured" class="image-thumb-box" data-msg="Signature Series is available with a paid subscription. To access this Series, please update your plan!" data-bs-toggle="modal" data-bs-target="#subscription-update-modal" href="javascript:void(0)">
                                                <img src="{{getThumbUrl(seriesdata.featured.video_thumb)}}">
                                                <p>Chapters</p>
                                            </div>
                                            <!-- <div class="image-thumb-box" *ngIf="seriesdata.featured" (click)="seriesPlaylist(seriesdata)">
                                                <img src="{{getThumbUrl(seriesdata.featured.video_thumb)}}">
                                                <p>Chapters</p>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                    
                </ng-container>
            </div>
            

            <div class="text-center" *ngIf="totalseries > series.length">
                <button class="btn btn-lg btn-gold3 me-4" (click)="showMore()">Load More</button>
            </div>
        </div>
    </section>
    <app-video-details modalid="staticBackdrop" [videoDetails]="videoDetails"></app-video-details>
</ng-template>
